import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initArticleSearchGrid from '../sections/article-search-grid';

ready(() => {
  initArticleSearchGrid();
});

onShopifySectionLoad(() => {
  initArticleSearchGrid();
});
